import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { MSmClientOpportunityEntity } from './m-sm-client-opportunity.entity';

@Index('opportunity_file__fk__file__id_fk', ['fkFileId'], {})
@Index('opportunity_file__fk_opportunity__id_fk', ['fkOpportunityId'], {})
@Entity('opportunity_file')
export class OpportunityFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: '_fk_opportunity_id', unsigned: true })
	public fkOpportunityId!: number;

	@ManyToOne(() => MSmClientOpportunityEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_opportunity_id', referencedColumnName: 'id' }])
	public fkOpportunity!: MSmClientOpportunityEntity;

	@ManyToOne(() => FileEntity, (file) => file.opportunityFiles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
